// Klucze camelCase pochodzą z resultsEngine (engineCalculator.js);
// PascalCase to fallback dla ścieżki legacy SP.
export const getRowKey = (r) => r.positionNumber ?? r.PositionNumber;
export const getStageRowValue = (r) => r.resultTime ?? r.ResultTime;
export const getAfterStageRowValue = (r) => r.totalTime ?? r.ResultAndPenalty;

// Zwraca Set kluczy wierszy, których wartość zmieniła się względem prev.
// Pusta prev = pierwsze dane, nic nie podświetlamy.
export const computeChangedRows = (prev, next, getKey, getValue) => {
  const changed = new Set();
  if (!prev.length) return changed;

  const prevMap = new Map(prev.map((r) => [getKey(r), getValue(r)]));
  next.forEach((r) => {
    const key = getKey(r);
    if (key === undefined || key === null) return;
    const prevValue = prevMap.get(key);
    if (prevValue === undefined || prevValue !== getValue(r)) {
      changed.add(key);
    }
  });
  return changed;
};
